import { PRODUCT } from '@ahmdigital/constants';

const CHEAPEST_PRODUCT = {
  HOSPITAL: PRODUCT.AMBULANCE_BASIC_EXCESS_750,
};

export default CHEAPEST_PRODUCT;
